// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutStaticPage-eslipinPage-wsWQ2 {
  font-family: 'Poppins', 'Segoe UI', Arial, sans-serif;
  color: #12395c;
  background: #ffffff; /* User requested white background */
  min-height: 100vh;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.AboutStaticPage-eslipinMain-YrYR2 {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  padding: 60px 0px 80px 0px;
  /* max-width: 1200px; */
  margin: 0 auto;
  width: 100%;
}

/* ---------- BANNER ---------- */

.AboutStaticPage-bannerSection-Dnxa6 {
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding: 0px 0px 0px 80px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-bottom: 60px;
  background: -webkit-gradient(linear, left top, left bottom, from(#ffffff), to(color-mix(in srgb, var(--secondary-cielo) 50%, transparent)));
  background: linear-gradient(#ffffff 0%, color-mix(in srgb, var(--secondary-cielo) 50%, transparent));
}

.AboutStaticPage-bannerText-HVvoX {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  padding-right: 40px;
}

.AboutStaticPage-bannerText-HVvoX h2 {
  font-size: 32px;
  font-weight: bold;
  font-family: var(--font-family-primary);
  color: var(--secondary-oscuro);
}

.AboutStaticPage-bannerText-HVvoX h1 {
  margin-top: 70px;
  font-size: 50px;
  font-weight: bold;
  font-family: var(--font-family-base);
  color: var(--secondary-esmeralda); /* green color as in the image */
  line-height: 1.2;
  margin-bottom: 35px;
}

.AboutStaticPage-bannerText-HVvoX p {
  font-size: 25px;
  color: var(--secondary-oscuro);
  line-height: 1.5;
}

.AboutStaticPage-bannerImage-i0aMn {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  overflow: hidden;
}

.AboutStaticPage-bgImage-V8Lun {
  width: 100%;
  max-width: 48dvw;
  height: 600px;
  border-radius: 350px 0px 0px 0px;
  -o-object-fit: cover;
     object-fit: cover;
}

.AboutStaticPage-bannerMascot-Pmk1Q {
  position: absolute;
  bottom: 0px;
  -webkit-transform: translate(-20dvw, -33%);
      -ms-transform: translate(-20dvw, -33%);
          transform: translate(-20dvw, -33%);
  width: 200px;
  height: auto;
}

/* ---------- CARDS ---------- */

.AboutStaticPage-cardsGrid-EFUaX {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 70px;
  margin-bottom: 80px;
  padding: 0px 80px 0px 80px;
}

.AboutStaticPage-missionCard-YkZxo, .AboutStaticPage-visionCard-SGMD7 {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  background: color-mix(in srgb, var(--secondary-cielo) 40%, transparent);
  border-radius: 19px;
  padding: 40px;
  position: relative;
}

.AboutStaticPage-missionCard-YkZxo h3, .AboutStaticPage-visionCard-SGMD7 h3 {
  font-size: 28px;
  font-weight: bold;
  color: #082a45;
  margin-bottom: 20px;
}

.AboutStaticPage-missionCard-YkZxo p, .AboutStaticPage-visionCard-SGMD7 p {
  font-size: 22px;
  color: var(--secondary-oscuro);
  max-width: 65%;
  line-height: 1.6;
  margin-bottom: 60px;
}

.AboutStaticPage-cardMascot-KxnDb {
  position: absolute;
  bottom: 10px;
  right: 20px;
  width: 200px;
  height: auto;
}

.AboutStaticPage-cardMascotRight-aiTvX {
  position: absolute;
  bottom: 10px;
  right: 20px;
  width: 200px;
  height: auto;
}

/* ---------- VALUES ---------- */

.AboutStaticPage-valuesSection-Ie4Vv {
  text-align: center;
  padding: 0px 80px 0px 80px;
}

.AboutStaticPage-valuesSubtitle-C9B55 {
  font-size: 22px;
  font-weight: bold;
  color: var(--primary-color); /* teal color */
  font-family: var(--font-family-primary);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0px;
}

.AboutStaticPage-valuesTitle-ub8qO {
  font-size: 32px;
  font-weight: bold;
  color: var(--secondary-oscuro);
  margin-bottom: 50px;
}

.AboutStaticPage-valuesGrid-orfiO {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 20px;
}

.AboutStaticPage-valueCard-tHy1U {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  /* background: #f7d5a3; */
  border: 1px solid var(--primary-color);
  border-radius: 15px;
  padding: 30px 60px;
  text-align: center;
}

.AboutStaticPage-valueIcon-gOKvR {
  width: 90px;
  height: 90px;
  background: color-mix(in srgb, var(--secondary-cielo) 40%, transparent);
  border-radius: 50%;
  margin: 0 auto 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-weight: bold;
  font-size: 24px;
  color: #082a45;
}

.AboutStaticPage-valueCard-tHy1U h4 {
  font-size: 28px;
  font-weight: bold;
  color: var(--secondary-oscuro);
  margin-bottom: 15px;
}

.AboutStaticPage-valueCard-tHy1U p {
  font-size: 22px;
  font-family: var(--font-family-base);
  color: var(--secondary-oscuro);
  line-height: 1.5;
}

@media (max-width: 1100px) {
  .AboutStaticPage-eslipinMain-YrYR2 { padding: 40px 0px; }

  .AboutStaticPage-bannerSection-Dnxa6 {
    grid-template-columns: 1fr 1.2fr;
    /* padding: 0px 40px; */
    margin-bottom: 30px;
    margin-top: 30px;
  }

  .AboutStaticPage-bannerText-HVvoX h2 { font-size: 28px; }
  .AboutStaticPage-bannerText-HVvoX h1 { margin-top: 20px; font-size: 40px; }
  .AboutStaticPage-bannerText-HVvoX p { font-size: 22px; }

  .AboutStaticPage-bgImage-V8Lun {
   /*  max-width: 100%;
    height: 450px; */
    -o-object-fit: cover;
       object-fit: cover;
  }

  .AboutStaticPage-bannerMascot-Pmk1Q {
    width: 180px;
    /* transform: translate(-40%, -20%); */
  }

  .AboutStaticPage-cardsGrid-EFUaX {
    padding: 0px 40px;
    gap: 40px;
  }

  .AboutStaticPage-missionCard-YkZxo p, .AboutStaticPage-visionCard-SGMD7 p {
    font-size: 20px;
  }

  .AboutStaticPage-valuesSection-Ie4Vv { padding: 0px 40px; }
  .AboutStaticPage-valueCard-tHy1U { padding: 30px 30px; }
}

@media (max-width: 860px) {
  .AboutStaticPage-eslipinMain-YrYR2 { padding: 30px 0px; }
  
  .AboutStaticPage-bannerSection-Dnxa6 { 
    grid-template-columns: 1fr; 
    padding: 20px;
    margin-top: 40px;
    background: none;
  }
  
  .AboutStaticPage-bannerText-HVvoX { padding-right: 0; margin-bottom: 20px; text-align: center; }
  .AboutStaticPage-bannerText-HVvoX h2 { font-size: 22px; }
  .AboutStaticPage-bannerText-HVvoX h1 { margin-top: 20px; font-size: 32px; }
  .AboutStaticPage-bannerText-HVvoX p { font-size: 18px; }
  
  .AboutStaticPage-bannerImage-i0aMn {
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  
  .AboutStaticPage-bgImage-V8Lun { 
    max-width: 100%; 
    height: auto;
    max-height: 300px;
    border-radius: 20px; 
  }
  
  .AboutStaticPage-bannerMascot-Pmk1Q {
    position: absolute;
    left: 50%;
    bottom: 0px;
    -webkit-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
            transform: translateX(-50%);
    width: 130px;
    height: auto;
  }
  
  .AboutStaticPage-cardsGrid-EFUaX { 
    -webkit-box-orient: vertical; 
    -webkit-box-direction: normal; 
        -ms-flex-direction: column; 
            flex-direction: column; 
    padding: 0px 20px;
    gap: 40px;
  }
  
  .AboutStaticPage-missionCard-YkZxo, .AboutStaticPage-visionCard-SGMD7 {
    padding: 30px;
  }

  .AboutStaticPage-missionCard-YkZxo h3, .AboutStaticPage-visionCard-SGMD7 h3 {
    text-align: center;
  }
  
  .AboutStaticPage-missionCard-YkZxo p, .AboutStaticPage-visionCard-SGMD7 p {
    max-width: 100%;
    font-size: 18px;
    margin-bottom: 150px; /* Space for centered mascot */
    text-align: center;
  }
  
  .AboutStaticPage-cardMascot-KxnDb, .AboutStaticPage-cardMascotRight-aiTvX {
    width: 150px;
    bottom: 20px;
    right: 50%;
    -webkit-transform: translateX(50%);
        -ms-transform: translateX(50%);
            transform: translateX(50%);
  }
  
  .AboutStaticPage-valuesSection-Ie4Vv {
    padding: 0px 20px;
  }

  .AboutStaticPage-valuesTitle-ub8qO {
    font-size: 26px;
  }
  
  .AboutStaticPage-valuesGrid-orfiO { 
    -webkit-box-orient: vertical; 
    -webkit-box-direction: normal; 
        -ms-flex-direction: column; 
            flex-direction: column; 
  }
  
  .AboutStaticPage-valueCard-tHy1U {
    padding: 30px 20px;
  }
  
  .AboutStaticPage-valueCard-tHy1U h4 {
    font-size: 24px;
  }
  
  .AboutStaticPage-valueCard-tHy1U p {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/static/about/AboutStaticPage.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;EACrD,cAAc;EACd,mBAAmB,EAAE,oCAAoC;EACzD,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,0BAA0B;EAC1B,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA,iCAAiC;;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAmB;EACnB,2IAAoG;EAApG,oGAAoG;AACtG;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,iCAAiC,EAAE,gCAAgC;EACnE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0CAAkC;MAAlC,sCAAkC;UAAlC,kCAAkC;EAClC,YAAY;EACZ,YAAY;AACd;;AAEA,gCAAgC;;AAChC;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,uEAAuE;EACvE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,iCAAiC;;AACjC;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B,EAAE,eAAe;EAC5C,uCAAuC;EACvC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uEAAuE;EACvE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qCAAe,iBAAiB,EAAE;;EAElC;IACE,gCAAgC;IAChC,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,uCAAiB,eAAe,EAAE;EAClC,uCAAiB,gBAAgB,EAAE,eAAe,EAAE;EACpD,sCAAgB,eAAe,EAAE;;EAEjC;GACC;oBACiB;IAChB,oBAAiB;OAAjB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA,uCAAiB,iBAAiB,EAAE;EACpC,mCAAa,kBAAkB,EAAE;AACnC;;AAEA;EACE,qCAAe,iBAAiB,EAAE;;EAElC;IACE,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,oCAAc,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;EACzE,uCAAiB,eAAe,EAAE;EAClC,uCAAiB,gBAAgB,EAAE,eAAe,EAAE;EACpD,sCAAgB,eAAe,EAAE;;EAEjC;IACE,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;IAC3B,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,oBAAoB,EAAE,8BAA8B;IACpD,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kCAA0B;QAA1B,8BAA0B;YAA1B,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".eslipinPage {\n  font-family: 'Poppins', 'Segoe UI', Arial, sans-serif;\n  color: #12395c;\n  background: #ffffff; /* User requested white background */\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.eslipinMain {\n  flex: 1;\n  padding: 60px 0px 80px 0px;\n  /* max-width: 1200px; */\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* ---------- BANNER ---------- */\n.bannerSection {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  padding: 0px 0px 0px 80px;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 60px;\n  background: linear-gradient(#ffffff 0%, color-mix(in srgb, var(--secondary-cielo) 50%, transparent));\n}\n\n.bannerText {\n  flex: 1;\n  padding-right: 40px;\n}\n\n.bannerText h2 {\n  font-size: 32px;\n  font-weight: bold;\n  font-family: var(--font-family-primary);\n  color: var(--secondary-oscuro);\n}\n\n.bannerText h1 {\n  margin-top: 70px;\n  font-size: 50px;\n  font-weight: bold;\n  font-family: var(--font-family-base);\n  color: var(--secondary-esmeralda); /* green color as in the image */\n  line-height: 1.2;\n  margin-bottom: 35px;\n}\n\n.bannerText p {\n  font-size: 25px;\n  color: var(--secondary-oscuro);\n  line-height: 1.5;\n}\n\n.bannerImage {\n  flex: 1;\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  overflow: hidden;\n}\n\n.bgImage {\n  width: 100%;\n  max-width: 48dvw;\n  height: 600px;\n  border-radius: 350px 0px 0px 0px;\n  object-fit: cover;\n}\n\n.bannerMascot {\n  position: absolute;\n  bottom: 0px;\n  transform: translate(-20dvw, -33%);\n  width: 200px;\n  height: auto;\n}\n\n/* ---------- CARDS ---------- */\n.cardsGrid {\n  display: flex;\n  gap: 70px;\n  margin-bottom: 80px;\n  padding: 0px 80px 0px 80px;\n}\n\n.missionCard, .visionCard {\n  flex: 1;\n  background: color-mix(in srgb, var(--secondary-cielo) 40%, transparent);\n  border-radius: 19px;\n  padding: 40px;\n  position: relative;\n}\n\n.missionCard h3, .visionCard h3 {\n  font-size: 28px;\n  font-weight: bold;\n  color: #082a45;\n  margin-bottom: 20px;\n}\n\n.missionCard p, .visionCard p {\n  font-size: 22px;\n  color: var(--secondary-oscuro);\n  max-width: 65%;\n  line-height: 1.6;\n  margin-bottom: 60px;\n}\n\n.cardMascot {\n  position: absolute;\n  bottom: 10px;\n  right: 20px;\n  width: 200px;\n  height: auto;\n}\n\n.cardMascotRight {\n  position: absolute;\n  bottom: 10px;\n  right: 20px;\n  width: 200px;\n  height: auto;\n}\n\n/* ---------- VALUES ---------- */\n.valuesSection {\n  text-align: center;\n  padding: 0px 80px 0px 80px;\n}\n\n.valuesSubtitle {\n  font-size: 22px;\n  font-weight: bold;\n  color: var(--primary-color); /* teal color */\n  font-family: var(--font-family-primary);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 0px;\n}\n\n.valuesTitle {\n  font-size: 32px;\n  font-weight: bold;\n  color: var(--secondary-oscuro);\n  margin-bottom: 50px;\n}\n\n.valuesGrid {\n  display: flex;\n  gap: 20px;\n}\n\n.valueCard {\n  flex: 1;\n  /* background: #f7d5a3; */\n  border: 1px solid var(--primary-color);\n  border-radius: 15px;\n  padding: 30px 60px;\n  text-align: center;\n}\n\n.valueIcon {\n  width: 90px;\n  height: 90px;\n  background: color-mix(in srgb, var(--secondary-cielo) 40%, transparent);\n  border-radius: 50%;\n  margin: 0 auto 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 24px;\n  color: #082a45;\n}\n\n.valueCard h4 {\n  font-size: 28px;\n  font-weight: bold;\n  color: var(--secondary-oscuro);\n  margin-bottom: 15px;\n}\n\n.valueCard p {\n  font-size: 22px;\n  font-family: var(--font-family-base);\n  color: var(--secondary-oscuro);\n  line-height: 1.5;\n}\n\n@media (max-width: 1100px) {\n  .eslipinMain { padding: 40px 0px; }\n\n  .bannerSection {\n    grid-template-columns: 1fr 1.2fr;\n    /* padding: 0px 40px; */\n    margin-bottom: 30px;\n    margin-top: 30px;\n  }\n\n  .bannerText h2 { font-size: 28px; }\n  .bannerText h1 { margin-top: 20px; font-size: 40px; }\n  .bannerText p { font-size: 22px; }\n\n  .bgImage {\n   /*  max-width: 100%;\n    height: 450px; */\n    object-fit: cover;\n  }\n\n  .bannerMascot {\n    width: 180px;\n    /* transform: translate(-40%, -20%); */\n  }\n\n  .cardsGrid {\n    padding: 0px 40px;\n    gap: 40px;\n  }\n\n  .missionCard p, .visionCard p {\n    font-size: 20px;\n  }\n\n  .valuesSection { padding: 0px 40px; }\n  .valueCard { padding: 30px 30px; }\n}\n\n@media (max-width: 860px) {\n  .eslipinMain { padding: 30px 0px; }\n  \n  .bannerSection { \n    grid-template-columns: 1fr; \n    padding: 20px;\n    margin-top: 40px;\n    background: none;\n  }\n  \n  .bannerText { padding-right: 0; margin-bottom: 20px; text-align: center; }\n  .bannerText h2 { font-size: 22px; }\n  .bannerText h1 { margin-top: 20px; font-size: 32px; }\n  .bannerText p { font-size: 18px; }\n  \n  .bannerImage {\n    justify-content: center;\n    width: 100%;\n    overflow: hidden;\n    position: relative;\n  }\n  \n  .bgImage { \n    max-width: 100%; \n    height: auto;\n    max-height: 300px;\n    border-radius: 20px; \n  }\n  \n  .bannerMascot {\n    position: absolute;\n    left: 50%;\n    bottom: 0px;\n    transform: translateX(-50%);\n    width: 130px;\n    height: auto;\n  }\n  \n  .cardsGrid { \n    flex-direction: column; \n    padding: 0px 20px;\n    gap: 40px;\n  }\n  \n  .missionCard, .visionCard {\n    padding: 30px;\n  }\n\n  .missionCard h3, .visionCard h3 {\n    text-align: center;\n  }\n  \n  .missionCard p, .visionCard p {\n    max-width: 100%;\n    font-size: 18px;\n    margin-bottom: 150px; /* Space for centered mascot */\n    text-align: center;\n  }\n  \n  .cardMascot, .cardMascotRight {\n    width: 150px;\n    bottom: 20px;\n    right: 50%;\n    transform: translateX(50%);\n  }\n  \n  .valuesSection {\n    padding: 0px 20px;\n  }\n\n  .valuesTitle {\n    font-size: 26px;\n  }\n  \n  .valuesGrid { \n    flex-direction: column; \n  }\n  \n  .valueCard {\n    padding: 30px 20px;\n  }\n  \n  .valueCard h4 {\n    font-size: 24px;\n  }\n  \n  .valueCard p {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"eslipinPage": `AboutStaticPage-eslipinPage-wsWQ2`,
	"eslipinMain": `AboutStaticPage-eslipinMain-YrYR2`,
	"bannerSection": `AboutStaticPage-bannerSection-Dnxa6`,
	"bannerText": `AboutStaticPage-bannerText-HVvoX`,
	"bannerImage": `AboutStaticPage-bannerImage-i0aMn`,
	"bgImage": `AboutStaticPage-bgImage-V8Lun`,
	"bannerMascot": `AboutStaticPage-bannerMascot-Pmk1Q`,
	"cardsGrid": `AboutStaticPage-cardsGrid-EFUaX`,
	"missionCard": `AboutStaticPage-missionCard-YkZxo`,
	"visionCard": `AboutStaticPage-visionCard-SGMD7`,
	"cardMascot": `AboutStaticPage-cardMascot-KxnDb`,
	"cardMascotRight": `AboutStaticPage-cardMascotRight-aiTvX`,
	"valuesSection": `AboutStaticPage-valuesSection-Ie4Vv`,
	"valuesSubtitle": `AboutStaticPage-valuesSubtitle-C9B55`,
	"valuesTitle": `AboutStaticPage-valuesTitle-ub8qO`,
	"valuesGrid": `AboutStaticPage-valuesGrid-orfiO`,
	"valueCard": `AboutStaticPage-valueCard-tHy1U`,
	"valueIcon": `AboutStaticPage-valueIcon-gOKvR`
};
module.exports = ___CSS_LOADER_EXPORT___;
